export default "__VITE_ASSET__l0FE1Kyd__"